export const SELECTOR_COMPANIES_BUDGETS_SELECTED = (state) => state.companiesBudgets.companiesBudgetSelected;

export const SELECTOR_COMPANIES_BUDGETS_TOTALS = (state) => state.companiesBudgets.companiesBudgetsTotals;

export const SELECTOR_COMPANIES_BUDGETS = (state) => Object.values(state.companiesBudgets.companiesBudgets);
